import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5ce28033"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-wrap ptb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-sm-3" }
const _hoisted_5 = { class: "col-sm-9" }
const _hoisted_6 = { class: "table-responsive-sm" }
const _hoisted_7 = { class: "table table-bordered" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "ttdbackground" }, "Intervalle du Poids en gramme", -1))
const _hoisted_10 = { class: "ttdbackground" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuProduit = _resolveComponent("MenuProduit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_MenuProduit)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("thead", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _hoisted_9,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distances, (header) => {
                    return (_openBlock(), _createElementBlock("th", {
                      class: "tablebackground",
                      key: header
                    }, _toDisplayString(header), 1))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.montants, (montant, inde) => {
                  return (_openBlock(), _createElementBlock("tr", { key: inde }, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(inde), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.distances, (dis) => {
                      return (_openBlock(), _createElementBlock("td", { key: dis }, _toDisplayString(_ctx.separateur(montant[dis]) || 'N/A') + "F CFA", 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}